import React from 'react';
import PropTypes from 'prop-types';

/**
 * Generic DataTable component with embedded styles
 * @param {Array<Object>} data           - Array of row objects
 * @param {Array<Object>} columns        - Column definitions: { key, title, render?, className? }
 * @param {string}        rowKey         - Field in row to use as React key
 */
export default function DataTable({ data, columns, rowKey = 'id' }) {
  return (
    <div style={styles.tableContainer}>
      <table style={styles.table}>
        <thead style={styles.tableHead}>
          <tr>
            {columns.map(col => (
              <th
                key={col.key}
                style={{ ...styles.th, ...(col.headerStyle || {}) }}
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map(row => (
            <tr key={row[rowKey] ?? Math.random()} style={styles.tr}>
              {columns.map(col => (
                <td
                  key={col.key}
                  style={{ ...styles.td, ...(col.cellStyle || {}) }}
                >
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}

          {data?.length === 0 && (
            <tr>
              <td colSpan={columns.length} style={styles.tdNodata}>
                <div style={{ textAlign: 'center', color: '#333333' }}>
                  No data available
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

DataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      render: PropTypes.func,
      headerStyle: PropTypes.object,
      cellStyle: PropTypes.object,
    })
  ).isRequired,
  rowKey: PropTypes.string,
};

// Embedded styles
const styles = {
   tableContainer: {
    overflowX: 'auto',
    background: '#fff',
    // marginTop: 16
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableHead: {
    backgroundColor: '#e9e9e9'
  },
  th: {
    verticalAlign: 'middle',
    textAlign: 'center',
    border: 'solid 1px #ccc',
    borderBottom: '2px solid #e0e0e0',
    padding: '8px 12px',
    fontSize: 14,
    color: '#000',
    height: 40,
  },
  tr: {
    borderBottom: '1px solid #f0f0f0'
  },
  td: {
    verticalAlign: 'middle',
    textAlign: 'center',
    border: 'solid 1px #ccc',
    padding: '10px 12px',
    fontSize: 14,
    color: '#000'
  },
  tdNodata: {
    verticalAlign: 'middle',
    textAlign: 'center',
    border: 'solid 1px #ccc',
    padding: '10px 12px',
    fontSize: 14,
    color: '#000',
    padding: '80px 10px'
  },
  statusDot: {
    display: 'inline-block',
    width: 12,
    height: 12,
    borderRadius: '50%',
    marginRight: 6
  },
  statusText: {
    fontSize: 12,
    fontWeight: '500',
    marginRight: 6,
    verticalAlign: 'middle'
  },
  idText: {
    fontSize: 12,
    color: '#000',
    marginTop: 4
  },
};